import React, { useState, useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import "./DropDownButtons.scss";

const DropDownButtons = ({
  showSelected,
  activeButton,
  setActiveButton,
  setAllCardsData,
  setCurrentPage,
  setCanFetchMore,
  createdByMeCount,
  createdByOthersCount,
  totalBannersCount,
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const meCount = Number(createdByMeCount || 0);
  const othersCount = Number(createdByOthersCount || 0);
  const allCount = Number(totalBannersCount || 0);

  const handleButtonClick = (buttonIndex) => {
    setAllCardsData([]);
    setCurrentPage(1);
    setActiveButton(buttonIndex);
    setCanFetchMore(false);
    setDropdownOpen(false);
  };

  const toggleDropdown = (isOpen) => {
    setDropdownOpen(isOpen);
  };

  useEffect(() => {
    setActiveButton(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getSelectedName = () => {
    if (activeButton === 1) {
      return `Created by Me (${meCount})`;
    } else if (activeButton === 2) {
      return `Created by Others (${othersCount})`;
    } else if (activeButton === 3) {
      return `All (${allCount})`;
    }
    return "";
  };

  return (
    <Dropdown
      show={dropdownOpen}
      onToggle={toggleDropdown}
      className="dropdown-button"
    >
      <Dropdown.Toggle onClick={() => setDropdownOpen(!dropdownOpen)}>
        {getSelectedName()}
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item
          onClick={() => {
            if (activeButton !== 1) {
              showSelected("me");
              handleButtonClick(1);
            }
          }}
          as="button"
          className={`btnLink ${activeButton === 1 ? "activeButton" : ""}`}
          style={{
            borderTopLeftRadius: "12px",
            borderTopRightRadius: "12px",
          }}
        >
          <span>Created by Me ({meCount})</span>
        </Dropdown.Item>

        <Dropdown.Item
          onClick={() => {
            if (activeButton !== 2) {
              showSelected("others");
              handleButtonClick(2);
            }
          }}
          as="button"
          className={`btnLink ${activeButton === 2 ? "activeButton" : ""}`}
        >
          <span>Created by Others ({othersCount})</span>
        </Dropdown.Item>

        <Dropdown.Item
          onClick={() => {
            if (activeButton !== 3) {
              showSelected("all");
              handleButtonClick(3);
            }
          }}
          as="button"
          className={`btnLink ${activeButton === 3 ? "activeButton" : ""}`}
          style={{
            borderBottomLeftRadius: "12px",
            borderBottomRightRadius: "12px",
          }}
        >
          <span>All ({allCount})</span>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default DropDownButtons;
